/**
 * Resolve the Terms / Privacy URLs.
 *
 * Order of precedence:
 *   1. Explicit env override (VITE_TERMS_URL / VITE_PRIVACY_URL). Lets the
 *      marketing team point these at an external CMS if ever needed.
 *   2. Internal fallback: the in-app /terms and /privacy routes served by
 *      apps/hub/src/routes/legal. Same-origin relative paths, so the links
 *      resolve in dev (localhost) and prod alike without extra env config.
 *
 * Used by SignupRoute (the signup consent links) and the PublicLanding footer.
 */

export function termsUrl(): string {
  return import.meta.env.VITE_TERMS_URL ?? "/terms";
}

export function privacyUrl(): string {
  return import.meta.env.VITE_PRIVACY_URL ?? "/privacy";
}
